import { isFacetVisible, PrimaryFacets, FacetId } from "../../../../types.js";
function parseFacets({
  facets,
  hasProductType,
  facetOrder,
  productTypeFacetValue
}) {
  const filteredFacets = facets.filter(isFacetVisible).filter(({ id }) => hasProductType || PrimaryFacets[id]).filter(
    ({ id }) => productTypeFacetValue !== "FRAMES" || id !== FacetId.isOfferedWithPrescriptions
  );
  if (!facetOrder?.length) {
    return filteredFacets;
  }
  return sortFacets(filteredFacets, facetOrder);
}
function sortFacets(facets, facetOrder) {
  const facetsCopy = Array.from(facets);
  const sorted = facetsCopy.sort((facetA, facetB) => {
    const orderA = facetOrder.indexOf(facetA.attribute);
    const orderB = facetOrder.indexOf(facetB.attribute);
    if (orderA === -1 && orderB !== -1 || orderA !== -1 && orderB === -1) {
      return orderA === -1 ? 1 : -1;
    }
    return orderA - orderB;
  });
  return sorted;
}
export {
  parseFacets
};
//# sourceMappingURL=parse-facets.js.map
